module.exports = __webpack_public_path__ + "static/KWS-8a1c3c24ae2d72e794a434148179d299.png";